import React from "react";
import {classNames} from "../../util/util-helpers";

export default function Card(props) {
    const {className, bodyClass, addBodyClass, addClass} = props;
    const defaultCardClass = "bg-inverse rounded-card border-tm-gray-300 border shadow-card";
    const defaultBodyClass = "py-3 px-6 space-y-4";

    return (
        <div className={classNames(className ?? defaultCardClass, addClass)}>
            <div className={classNames(bodyClass ?? defaultBodyClass, addBodyClass)}>
                {props.children}
            </div>
        </div>
    )
}

